import React, { useEffect, useState } from "react";
import { Flex, Form } from "antd";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";
import TextArea from "antd/es/input/TextArea";
import { useDispatch } from "react-redux";
import { setModalOpen } from "@/reducers/commonSlice";
import { submitMentorRequest } from "@/services/students/submitMentorRequest";
import { showNotification } from "@/components/toaster/Toaster";

const MentorApplicationDescription = ({ isOpen, onClose = () => {}, isGuide = false }) => {
  console.log("isGuide", isGuide);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      await submitMentorRequest({
        category: "General",
        description: values.description,
      });
      showNotification({
        message: "Your request has been submitted successfully",
        type: "success",
      });
      form.resetFields();
      dispatch(setModalOpen(false));
    } catch (error) {
      console.error("Error submitting request:", error);
      showNotification({
        message: "Failed to submit request. Please try again.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
    dispatch(setModalOpen(false));
  };

  useEffect(() => {
    if (isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  const message = isGuide ? (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <p>
        It looks like you've already applied to become a mentor. Please wait while our internal team
        reviews your application. In the meantime, feel free to browse our services.
      </p>
      <p>Want to tell us more? Leave a message below.</p>
    </div>
  ) : (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <p>It appears that you do not currently meet our criteria to become a mentor.</p>
      <p>
        However, if you believe you are eligible, you can leave us a message below for further
        review.
      </p>
    </div>
  );

  return (
    <ModalComponent isOpen={isOpen} width={500}>
      <Flex vertical gap="1rem" align="center">
        <div className="body-b3">{message}</div>
        <Form form={form} layout="vertical" style={{ width: "100%" }} onFinish={handleSubmit}>
          <Form.Item
            name="description"
            rules={[
              {
                required: true,
                message: "Description field is required",
              },
            ]}
          >
            <TextArea
              autoSize={{ minRows: 4, maxRows: 7 }}
              placeholder="Enter your description..."
            />
          </Form.Item>
          <Flex gap="1rem" justify="center">
            <ButtonComponent
              label="Submit"
              type="primary"
              onClick={handleSubmit}
              loading={loading}
            />
            <ButtonComponent
              label="Cancel"
              type="default"
              onClick={handleCancel}
              disabled={loading}
            />
          </Flex>
        </Form>
        <div className="body-b3">
          <p>
            Still confused? Email us at <a href="mailto:mentor@inforens.com">mentor@inforens.com</a>
            .
          </p>
        </div>
      </Flex>
    </ModalComponent>
  );
};

export default MentorApplicationDescription;
